import { isIos } from "@/utils/lodash";
import { getDeviceInfo } from "@/utils/js_bridge_info";
/**
 *  ==================== INS BASE ===========================
 */
export const INS_APP_INFO = {
  appId: "124024574287414",
  name: "Instagram",
  version: "123.1.0.26.115",
  bundleVersion: "26.0.0.18.87 (83603364)",
  apihost: "https://i.instagram.com",
  capabilities: "36r/Bw==",
  secret_key_1:
    "D1IOUwNQD1ACVAMCAFdVAQAHB1AFAgQDBgEPUgIHBFcHVwFSAQMDVQ9TUgdXDwIEVFIDBg4CAA8EAFMEVwRTUg==",
  secret_key_2:
    "ZThkOWk6ZTpoPmloaj0/a2ptbTpvaG5pbGtlOGhtbj1tPWs4a2lpP2U5OG09ZWhuPjhpbGRoamVuajluPW45OA==",
  connection_speed: "-1kbps",
  BUILD: "190542906",
  CAPABILITIES: "36r/dw==",
  FACEBOOK_ID: "124024574287414",
  ig_sig_key_version: "5"
};

export const IOS_HEADERS = () => {
  const MACHINE =
    isIos() && getDeviceInfo().machine ? getDeviceInfo().machine : "iPhone11,2";
  const SYSTEM_VERSION =
    isIos() && getDeviceInfo().device && getDeviceInfo().device.system_version
      ? getDeviceInfo().device.system_version.replace(/\./g, "_")
      : "11_2";
  const SCALE =
    isIos() && getDeviceInfo().screen_scale
      ? getDeviceInfo().screen_scale.toFixed(2)
      : "11_2";

  return {
    "User-Agent": `${INS_APP_INFO.name} ${INS_APP_INFO.version} (${MACHINE}; iOS ${SYSTEM_VERSION}; en_US; en-US; scale=${SCALE}; gamut=normal; 1080x1920; ${INS_APP_INFO.FACEBOOK_ID} ) AppleWebKit/420+`,
    Accept: "*/*",
    "Accept-Language": "en-US;q=1.0",
    "X-IG-Connection-Type": "WiFi",
    "X-Bloks-Version-Id":
      "34751ed5be6fbaacccb5e967fd6ca873ba78ccded38e3c1df333e62210f2ec2f",
    "X-IG-Capabilities": INS_APP_INFO.CAPABILITIES,
    "X-IG-App-ID": INS_APP_INFO.FACEBOOK_ID,
    "X-IG-ABR-Connection-Speed-KBPS": "0",
    "X-IG-Connection-Speed": "-1kbps",
    "X-IG-Bandwidth-Speed-KBPS": "0.000",
    "X-IG-Device-Locale": "en-US"
  };
};
